import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";

// dashboard
import { DashboardPage } from "./pages/dashboard/DashboardPage";

// user
import { UserPage } from "./pages/user/UserPage";
import { UserEdit } from "./pages/user/UserEdit";
import { BusinessGroupPage } from "./pages/businessGroup/BusinessGroupPage";
import { UserCreate } from "./pages/user/UserCreate";
import { ChangePassword } from "./modules/UserProfile/ChangePassword";
import { PermissionEdit } from "./pages/user/PermissionEdit";
import { BusinessParameterPage } from "./pages/businessParameter/BusinessParameterPage";
import { MasterMenuPage } from "./pages/menu/MasterMenuPage";
import { OfficePage } from "./pages/office/OfficePage";
import { OfficeEdit } from "./pages/office/OfficeEdit";
import { UserView } from "./pages/user/UserView";
import { MotorPoolPage } from "./pages/motorPool/MotorPoolPage";
import { LabelTemplateCreate } from "./pages/motorPool/LabelTemplateCreate";
import { PermissionView } from "./pages/user/PermisionVIew";
import { LabelTemplateEdit } from "./pages/motorPool/LabelTemplateEdit";
import { OfficeView } from "./pages/office/OfficeView";
import { LabelTemplateView } from "./pages/motorPool/LabelTemplateView";
import { PreferencesEdit } from "./pages/motorPool/PreferencesEdit";
import { ClientPage } from "./pages/client/ClientPage";
import { ClientEdit } from "./pages/client/ClientEdit";
import { PartyPage } from "./pages/party/PartyPage";
import { PartyEdit } from "./pages/party/PartyEdit";
import { ProductRelatedPage } from "./pages/productRelated/ProductRelatedPage";
import { ProductMasterEdit } from "./pages/productRelated/ProductMasterEdit";
import { MiscellaneousPage } from "./pages/miscellaneous/MiscellaneousPage";
import { MasterUploadEdit } from "./pages/miscellaneous/MasterUploadEdit";
import { LocationRelatedPage } from "./pages/location/LocationRelatedPage";
import { LocationManagementPage } from "./pages/locationManagement/LocationManagementPage";
import { MotorPoolEdit } from "./pages/locationManagement/MotorPoolEdit";
import { MotorPoolAreaEdit } from "./pages/locationManagement/MotorPoolAreaEdit";
import { RoleTab } from "./pages/user/RoleTab";
import { UserTab } from "./pages/user/UserTab";
import { InboundCreate } from "./pages/inbound/inboundCreate";
import { OverviewEdit } from "./pages/inbound/OverviewEdit";
import { OverviewPage } from "./pages/inbound/OverviewPage";
import { WorkflowEdit } from "./pages/inbound/WorkflowEdit";
import { BookingPage } from "./pages/booking/BookingPage";
import { BookingCreate } from "./pages/booking/BookingCreate";
import { BookingEdit } from "./pages/booking/BookingEdit";
import { OutboundPage } from "./pages/outbound/OutboundPage";
import { OutboundCreate } from "./pages/outbound/OutboundCreate";
import { OutboundEdit } from "./pages/outbound/OutboundEdit";
import { WorkflowOutbound } from "./pages/outbound/WorkflowOutbound";
import { InventoryPage } from "./pages/inventory/InventoryPage";
import {
  MaintenancePage,
  MantenancePage,
} from "./pages/maintenance/MaintenancePage";
import { MaintenanceCreate } from "./pages/maintenance/MaintenanceCreate";
import { MaintenanceEdit } from "./pages/maintenance/MaintenanceEdit";
import { StocktakePage } from "./pages/stocktake/StocktakePage";
import { StocktakeCreate } from "./pages/stocktake/StocktakeCreate";
import { WorkflowMaintenance } from "./pages/maintenance/WorkflowMaintenance";
import { StocktakeEdit } from "./pages/stocktake/StocktakeEdit";
import { MovementPage } from "./pages/movement/MovementPage";
import { MovementCreate } from "./pages/movement/MovementCreate";
import { MovementEdit } from "./pages/movement/MovementEdit";
import { InfoUpdatePage } from "./pages/infoUpdate/InfoUpdatePage";
import { InfoUpdateCreate } from "./pages/infoUpdate/InfoUpdateCreate";
import { WorkflowMaintenanceRePDI } from "./pages/maintenance/WorkflowMaintenanceRePDI";
import { WorkflowStocktake } from "./pages/stocktake/WorkflowStocktake";
import { WorkflowMovement } from "./pages/movement/WorkflowMovement";
import { InfoUpdateEdit } from "./pages/infoUpdate/InfoUpdateEdit";
import { WorkflowInfoUpdate } from "./pages/infoUpdate/WorkflowInfoUpdate";
import { ReportIssuePage } from "./pages/inventory/ReportIssuePage";
import { ActivityPage } from "./pages/activity/ActivityPage";
import { MonitorPage } from "./pages/activity/MonitorPage";
import { PolicyPage } from "./pages/policy/PolicyPage";
import { ReportInboundPage } from "./pages/report/inbound/ReportInboundPage";
import { RDMPage } from "./pages/report/RDM/RDMPage";
import { ReportBookingPage } from "./pages/report/booking/ReportBookingPage";
import { ReportOutboundPage } from "./pages/report/outbond/ReportOutboundPage";
import { ReportRciPage } from "./pages/report/rci/ReportRciPage";
import { ReportPdiPage } from "./pages/report/pdi-in/ReportPdiPage";
import { ReportMaintenancePage } from "./pages/report/maintenance/ReportMaintenancePage";
import { ReportPickingPage } from "./pages/report/picking/ReportPickingPage";
import { ReportHandoverPage } from "./pages/report/handover/ReportHandoverPage";
import { ReportStocktakePage } from "./pages/report/stocktake/ReportStocktakePage";
import { ReportLocationPage } from "./pages/report/location/ReportLocationPage";
import { ReportVehicleAgingPage } from "./pages/report/vehicleAging/ReportVehicleAgingPage";
import { ReportControlPenaltyPage } from "./pages/report/controlPenaltyParking/ReportControlPenaltyPage";
import { ReportInventoryPage } from "./pages/report/vehicleInventory/ReportInventoryPage";
import { ReportVehicleInfoPage } from "./pages/report/vehicleInfo/ReportVehicleInfoPage";
import { ReportIssueMenuPage } from "./pages/reportIssue/ReportIssueMenuPage";
import { SapStatusPage } from "./pages/sapStatus/SapStatusPage";
import { VehicleInformationPage } from "./pages/transactionLog/VehicleInformationPage";
import { VehicleTransactionLogPage } from "./pages/transactionLog/VehicleTransactionLogPage";
import AccountInformation from "./modules/UserProfile/AccountInformation";

const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />
        {/* Dashboard */}
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/change-password" component={ChangePassword} />
        {/* User */}
        <ContentRoute
          path="/administration/management-user/role/view/:id"
          component={PermissionView}
        />
        <ContentRoute
          path="/administration/management-user/role/edit/:id"
          component={PermissionEdit}
        />
        <ContentRoute
          path="/administration/management-user/edit/:id"
          component={UserEdit}
        />
        <ContentRoute
          path="/administration/management-user/view/:id"
          component={UserView}
        />
        <ContentRoute
          path="/administration/management-user/create"
          component={UserCreate}
        />
        <ContentRoute
          path="/administration/management-user/role"
          component={UserPage}
        />
        <ContentRoute
          path="/administration/management-user/user"
          component={UserPage}
        />
        <ContentRoute
          path="/administration/management-user"
          component={UserPage}
        />
        <ContentRoute
          path="/administration/user-business-group"
          component={BusinessGroupPage}
        />
        {/* bispar */}
        <ContentRoute
          path="/administration/business-parameter"
          component={BusinessParameterPage}
        />
        {/* Menu */}
        <ContentRoute
          path="/administration/menu/menu-master-data"
          component={MasterMenuPage}
        />
        {/* office */}
        <ContentRoute
          path="/administration/office-management/view/:id"
          component={OfficeView}
        />
        <ContentRoute
          path="/administration/office-management/edit/:id"
          component={OfficeEdit}
        />
        <ContentRoute
          path="/administration/office-management"
          component={OfficePage}
        />
        {/* Label Tempalte - motor pool */}
        <ContentRoute
          path="/administration/motor-pool/preferences/edit/:id"
          component={PreferencesEdit}
        />
        <ContentRoute
          path="/administration/motor-pool/view/:id"
          component={LabelTemplateView}
        />
        <ContentRoute
          path="/administration/motor-pool/edit/:id"
          component={LabelTemplateEdit}
        />
        <ContentRoute
          path="/administration/motor-pool/create-labeltpl"
          component={LabelTemplateCreate}
        />
        <ContentRoute
          path="/administration/motor-pool/preferences"
          component={MotorPoolPage}
        />
        <ContentRoute
          path="/administration/motor-pool/label"
          component={MotorPoolPage}
        />
        <ContentRoute
          path="/administration/motor-pool"
          component={MotorPoolPage}
        />
        {/* Client */}
        <ContentRoute
          path="/administration/client/edit/:id"
          component={ClientEdit}
        />
        <ContentRoute path="/administration/client" component={ClientPage} />
        {/* Party */}
        <ContentRoute
          path="/master/party-master/edit/:id"
          component={PartyEdit}
        />
        <ContentRoute path="/master/party-master" component={PartyPage} />
        {/* Product Related */}
        <ContentRoute
          path="/master/product-related/product-master/edit/:id"
          component={ProductMasterEdit}
        />
        <ContentRoute
          path="/master/product-related"
          component={ProductRelatedPage}
        />
        {/* miscellaneous Related */}
        <ContentRoute
          path="/master/miscellaneous/master-upload/edit/:id"
          component={MasterUploadEdit}
        />
        <ContentRoute
          path="/master/miscellaneous"
          component={MiscellaneousPage}
        />
        {/*location-management */}
        <ContentRoute
          path="/motor-pool/location-management/area/:id"
          component={MotorPoolAreaEdit}
        />
        <ContentRoute
          path="/motor-pool/location-management/motor-pool/:id"
          component={MotorPoolEdit}
        />
        <ContentRoute
          path="/motor-pool/location-management"
          component={LocationManagementPage}
        />
        {/* Locatioan Realated */}
        <ContentRoute
          path="/master/location/country-master"
          component={LocationRelatedPage}
        />
        {/*inbound */}
        <ContentRoute
          path="/inbound/workflow/edit/:id"
          component={WorkflowEdit}
        />
        <ContentRoute path="/inbound/edit/:id" component={OverviewEdit} />
        <ContentRoute path="/inbound/create" component={InboundCreate} />
        <ContentRoute path="/inbound" component={OverviewPage} />
        {/*Booking*/}
        <ContentRoute
          path="/outbound/booking/edit/:id"
          component={BookingEdit}
        />
        <ContentRoute
          path="/outbound/booking/create"
          component={BookingCreate}
        />
        <ContentRoute path="/outbound/booking" component={BookingPage} />
        {/* outbound */}
        <ContentRoute
          path="/outbound/job/workflow/edit/:id"
          component={WorkflowOutbound}
        />
        <ContentRoute path="/outbound/job/edit/:id" component={OutboundEdit} />
        <ContentRoute path="/outbound/job/create" component={OutboundCreate} />
        <ContentRoute path="/outbound/job" component={OutboundPage} />
        {/* Vehicle Transaction Log */}
        <ContentRoute
          path="/motor-pool/vehicle-information/:id"
          component={VehicleTransactionLogPage}
        />
        {/* Vehicle Information */}
        <ContentRoute
          path="/motor-pool/vehicle-information"
          component={VehicleInformationPage}
        />
        {/* inventory */}
        <ContentRoute
          path="/motor-pool/inventory/report-issue/:id"
          component={ReportIssuePage}
        />
        <ContentRoute path="/motor-pool/inventory" component={InventoryPage} />
        {/* maintenance */}
        <ContentRoute
          path="/motor-pool/maintenance/pdi/workflow/edit/:id"
          component={WorkflowMaintenanceRePDI}
        />
        <ContentRoute
          path="/motor-pool/maintenance/workflow/edit/:id"
          component={WorkflowMaintenance}
        />
        <ContentRoute
          path="/motor-pool/maintenance/edit/:id"
          component={MaintenanceEdit}
        />
        <ContentRoute
          path="/motor-pool/maintenance/create"
          component={MaintenanceCreate}
        />
        <ContentRoute
          path="/motor-pool/maintenance"
          component={MaintenancePage}
        />
        {/* Stocktake */}
        <ContentRoute
          path="/motor-pool/stocktake/workflow/edit/:id"
          component={WorkflowStocktake}
        />
        <ContentRoute
          path="/motor-pool/stocktake/edit/:id"
          component={StocktakeEdit}
        />
        <ContentRoute
          path="/motor-pool/stocktake/create"
          component={StocktakeCreate}
        />
        <ContentRoute path="/motor-pool/stocktake" component={StocktakePage} />
        {/* Movement */}
        <ContentRoute
          path="/motor-pool/movement/workflow/edit/:id"
          component={WorkflowMovement}
        />
        <ContentRoute
          path="/motor-pool/movement/edit/:id"
          component={MovementEdit}
        />
        <ContentRoute
          path="/motor-pool/movement/create"
          component={MovementCreate}
        />
        <ContentRoute path="/motor-pool/movement" component={MovementPage} />
        {/* infoUpdate */}
        <ContentRoute
          path="/motor-pool/info-update/workflow/edit/:id"
          component={WorkflowInfoUpdate}
        />
        <ContentRoute
          path="/motor-pool/info-update/edit/:id"
          component={InfoUpdateEdit}
        />
        <ContentRoute
          path="/motor-pool/info-update/create"
          component={InfoUpdateCreate}
        />
        <ContentRoute
          path="/motor-pool/info-update"
          component={InfoUpdatePage}
        />
        {/* activity */}
        <ContentRoute
          path="/motor-pool/activity-monitor/type"
          component={MonitorPage}
        />
        <ContentRoute
          path="/motor-pool/activity-monitor"
          component={ActivityPage}
        />
        {/* policy */}
        <ContentRoute path="/administration/policy" component={PolicyPage} />
        {/* Reporting */}
        <ContentRoute path="/report/download-manager" component={RDMPage} />
        <ContentRoute
          path="/report/inbound-transaction"
          component={ReportInboundPage}
        />
        <ContentRoute
          path="/report/booking-details"
          component={ReportBookingPage}
        />
        <ContentRoute
          path="/report/outbound-trans"
          component={ReportOutboundPage}
        />
        <ContentRoute path="/report/rci-details" component={ReportRciPage} />
        <ContentRoute path="/report/pdi-details" component={ReportPdiPage} />
        <ContentRoute
          path="/report/Maintenance-details"
          component={ReportMaintenancePage}
        />
        <ContentRoute
          path="/report/confirmed-picking"
          component={ReportPickingPage}
        />
        <ContentRoute
          path="/report/confirmed-handover"
          component={ReportHandoverPage}
        />
        <ContentRoute
          path="/report/stocktake-details"
          component={ReportStocktakePage}
        />
        <ContentRoute
          path="/report/location-capacity"
          component={ReportLocationPage}
        />
        <ContentRoute
          path="/report/vehicle-aging"
          component={ReportVehicleAgingPage}
        />{" "}
        <ContentRoute
          path="/report/inventory"
          component={ReportInventoryPage}
        />
        <ContentRoute
          path="/report/control-penalty"
          component={ReportControlPenaltyPage}
        />
        <ContentRoute
          path="/report/vehicle-information"
          component={ReportVehicleInfoPage}
        />
        {/* Repot Issue */}
        <ContentRoute
          path="/motor-pool/report-issue"
          component={ReportIssueMenuPage}
        />
        {/* Repot Issue */}
        <ContentRoute
          path="/outbound/sap-status-update"
          component={SapStatusPage}
        />
        <Route path="/user-profile" component={AccountInformation} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
